<div *ngIf="global_texts" class="all-content login">
  <div class="content">
    <div class="inner-content w-100">

      <!-- Left Module -->
      <div class="left-module bloc-image"></div>

      <!-- Right Module -->
      <div class="right-module py-0 px-5 py-lg-5 justify-content-center align-items-center">
        <app-logos-unlogged></app-logos-unlogged>

        <!-- Import here the component account.complement -->
        <app-account></app-account>

      </div>
    </div>
  </div>
</div>

